import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import TestingVector from 'assets/vectors/Testing.svg';
import MoleculeVector from 'assets/vectors/Molecule.svg';
import Helmet from 'components/Helmet';
import Button from 'components/Button';
import './index.css';

function LevelTest() {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className='layout'>
            <Helmet
                title='Free SAT Practice Test - The SAT Crash Course'
                description='Take a free digital SAT practice test and receive a detailed report card for free! Get to know how the new SAT is structured to learn how to tackle the test.'
            />
            <div className='levelTest'>
                <img
                    className='levelTest__background'
                    src={MoleculeVector}
                />
                <h1 className='levelTest__title'>
                    Free SAT Practice Test
                </h1>
                <h2 className='levelTest__subtitle'>
                    for Digital SAT
                </h2>
                
                <p className='levelTest__prompt'>
                    Welcome to The SAT Crash Course!<br/><br/>
                    This mini SAT practice test is a short version of our full-length practice tests. The test simulates the new Digital SAT, with similar format and question styles. Students can use this test to get a sense of how the new SAT is designed and understand their knowledge levels on the SAT topics.
                </p>
                <img
                    className='levelTest__vector'
                    src={TestingVector}
                    alt='Testing'
                />
                <p className='levelTest__prompt'>
                    <b>Test Description</b><br/>
                    There are 2 subjects in this test : Reading & Writing and Math. You may decide to take both subjects all at once or take 1 subject at a time. If you decide to take 1 subject, you may exit out of the test after you complete the subject test. If you leave while taking a test without saving, your progress may NOT be saved. There will be multiple-choice questions as well as student-produced response questions, like in the new SAT test.
                </p>
                <p className='levelTest__prompt'>
                    <b>Timing</b><br/>
                    Reading & Writing : 2 modules, 32 minutes each<br/>
                    10-minute break<br/>
                    Math : 2 modules, 35 minutes each
                </p>
                <p className='levelTest__prompt'>
                    <b>Score Report</b><br/>
                    You will be given a report card that displays your strengths and weaknesses after you complete the entire test.
                </p>
                <p className='levelTest__prompt'>
                    Please treat this as a real SAT exam. This will ensure that you get an accurate score report, which will help you plan out your SAT prep. If you wish to take full-length practice tests, you can access our 10+ <Link to='/tests/digital-sat'>digital SAT practice tests</Link> that will give you a complete experience of the digital SAT test.
                </p>
                <p className='levelTest__prompt'>
                    Hope this test will be a step towards your excellence on test day. Thank you and good luck!
                </p>
                <Button
                    className='levelTest__button'
                    onClick={() => navigate('/sign-in', {
                        state: { referrer: location.pathname }
                    })}
                >
                    TAKE FREE LEVEL TEST
                </Button>
            </div>
        </div>
    );
}

export default LevelTest;